import { render } from "./CardH.vue?vue&type=template&id=5848512c"
import script from "./CardH.vue?vue&type=script&lang=js"
export * from "./CardH.vue?vue&type=script&lang=js"

import "./CardH.vue?vue&type=style&index=0&id=5848512c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__